import React, {useEffect, useRef, useState} from 'react';
import {Pause, Play, Volume2} from 'lucide-react';

const VideoPlayer = ({src, poster, onVideoEnded, setCanContinue}) => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [progress, setProgress] = useState(0);
    const [volume, setVolume] = useState(1);

    useEffect(() => {

        if (progress > 90) {
            setCanContinue(true);
        } else {
            setCanContinue(false);
        }
    }, [progress]);

    const togglePlay = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };


    const handleVolumeChange = (e) => {
        const newVolume = parseFloat(e.target.value);
        setVolume(newVolume);
        if (videoRef.current) {
            videoRef.current.volume = newVolume;
        }
    };

    const formatTime = (time: number) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };


    const handleTimeUpdate = () => {
        if (videoRef.current) {
            const current = videoRef.current.currentTime;
            const duration = videoRef.current.duration;
            const percent = (current / duration) * 100;
            setProgress(percent);
        }
    };

    const handleLoadedMetadata = () => {
        if (videoRef.current) {
            // ("مدت زمان ویدیو:", videoRef.current.duration);
        }
    };

    return (
        <>


            <div className="relative bg-black rounded-lg overflow-hidden shadow-xl">

                <video

                    controls={true}
                    onError={(e) => {
                        setIsPlaying(false);
                        console.error(e)
                    }}
                    ref={videoRef}
                    src={src}
                    poster={poster}
                    onTimeUpdate={handleTimeUpdate}
                    onLoadedMetadata={handleLoadedMetadata}
                    onEnded={() => {
                        setIsPlaying(false);
                        onVideoEnded();
                    }}
                    className="w-full aspect-video"
                    onPlay={() => setIsPlaying(true)}
                    onPause={() => setIsPlaying(false)}
                />

                <div
                    className="hidden absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">

                    <div className="flex items-center gap-4 text-white">
                        <button
                            onClick={togglePlay}
                            className="flex items-center justify-center w-10 h-10 bg-blue-600 hover:bg-blue-700 rounded-full transition-colors"
                        >
                            {isPlaying ? <Pause size={20}/> : <Play size={20}/>}
                        </button>

                        <div className="flex-1">
                            <div className="flex items-center gap-2 text-sm">
                                <span>{formatTime(currentTime)}</span>
                                <span>/</span>
                                <span>{formatTime(duration)}</span>
                            </div>
                        </div>

                        <div className="flex items-center gap-2">
                            <Volume2 size={18}/>
                            <input
                                type="range"
                                min="0"
                                max="1"
                                step="0.1"
                                value={volume}
                                onChange={handleVolumeChange}
                                className="w-20 h-2 bg-gray-600 rounded-lg appearance-none cursor-pointer"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-4">
                <div className="flex justify-between items-center mb-2">
                    <span className="text-sm text-gray-600">پیشرفت مشاهده</span>
                    <span className="text-sm font-medium text-blue-600">
                      {progress.toFixed(1)}%
                    </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                        className="bg-gradient-to-r from-blue-500 to-blue-600 h-2 rounded-full transition-all duration-300"
                        style={{width: `${progress}%`}}
                    ></div>
                </div>
            </div>


        </>
    )
        ;
};

export default VideoPlayer;
